const CLIENT_MESSAGES = ["POWERED_BY", "MEETING_WITH", "FROM", "CURRENTLY_SET", "BACK", "SET_MEETING", "CHOOSE_ANOTHER", "MEET",
    "CALENDAR_UNAVAILABLE", "ON", "NUMBER_PROMPT", "NAME", "EMAIL", "PHONE_NUMBER", "SET_MEETING_ERROR", "ENTER_NAME", "VALID_PHONE",
    "VALID_EMAIL", "CONFIRMED", "SCHEDULED_FOR", "INVITE_SENT"];

export const ClientMessages = CLIENT_MESSAGES.reduce((acc, msg) => Object.assign(acc, {[msg]: msg}), {});

export const getMessage = (msg, locale, variables) => messages[locale || "en"][msg]?.(variables);

const messages = {
    en: {
        [ClientMessages.POWERED_BY]: () => "Scheduler by",
        [ClientMessages.MEETING_WITH]: (minutes) => (minutes ? `${minutes} minute meeting with` : "Meeting with"),
        [ClientMessages.FROM]: () => "from",
        [ClientMessages.CURRENTLY_SET]: () => "Currently set to meet",
        [ClientMessages.BACK]: () => "Back",
        [ClientMessages.SET_MEETING]: () => "Set Meeting",
        [ClientMessages.CHOOSE_ANOTHER]: () => "Choose Another Time",
        [ClientMessages.MEET]: () => "Meet",
        [ClientMessages.CALENDAR_UNAVAILABLE]: () => "This calendar is currently unavailable.",
        [ClientMessages.ON]: () => "On",
        [ClientMessages.NUMBER_PROMPT]: (repName) => `Please provide a phone number so ${repName} will be able to contact you`,
        [ClientMessages.NAME]: () => "Name",
        [ClientMessages.EMAIL]: () => "Email address",
        [ClientMessages.PHONE_NUMBER]: () => "Phone number",
        [ClientMessages.SET_MEETING_ERROR]: () => "couldn't set meeting",
        [ClientMessages.ENTER_NAME]: () => "Please enter your name",
        [ClientMessages.VALID_PHONE]: () => "Please provide a valid phone number",
        [ClientMessages.VALID_EMAIL]: () => "Please provide a valid email address",
        [ClientMessages.CONFIRMED]: () => "Confirmed",
        [ClientMessages.SCHEDULED_FOR]: () => "is scheduled for",
        [ClientMessages.INVITE_SENT]: () => "A calendar invitation has been sent to your email address.",
    },
    es: {
        [ClientMessages.POWERED_BY]: () => "Planificador por",
        [ClientMessages.MEETING_WITH]: (minutes) => (minutes ? `Reunión de ${minutes} minutos con` : "La reunión con"),
        [ClientMessages.FROM]: () => "de",
        [ClientMessages.CURRENTLY_SET]: () => "Actualmente programado para reunirse",
        [ClientMessages.BACK]: () => "Atrás",
        [ClientMessages.SET_MEETING]: () => "Establecer reunión",
        [ClientMessages.CHOOSE_ANOTHER]: () => "Elige otra hora",
        [ClientMessages.MEET]: () => "Reunir",
        [ClientMessages.CALENDAR_UNAVAILABLE]: () => "Este calendario no está disponible actualmente.",
        [ClientMessages.ON]: () => "El",
        [ClientMessages.NUMBER_PROMPT]: (repName) => `Proporcione un número de teléfono para que ${repName} pueda contactarlo`,
        [ClientMessages.NAME]: () => "Nombre",
        [ClientMessages.EMAIL]: () => "Dirección de email",
        [ClientMessages.PHONE_NUMBER]: () => "Número de teléfono",
        [ClientMessages.SET_MEETING_ERROR]: () => "no se pudo programar la reunión",
        [ClientMessages.ENTER_NAME]: () => "Por favor, escriba su nombre",
        [ClientMessages.VALID_PHONE]: () => "Por favor ingrese un número de teléfono válido",
        [ClientMessages.VALID_EMAIL]: () => "Por favor ingrese su dirección de email válida",
        [ClientMessages.CONFIRMED]: () => "Confirmada",
        [ClientMessages.SCHEDULED_FOR]: () => "está programada para",
        [ClientMessages.INVITE_SENT]: () => "Se ha enviado una invitación de calendario a su dirección de email.",
    },
    de: {
        [ClientMessages.POWERED_BY]: () => "Terminplaner von",
        [ClientMessages.MEETING_WITH]: (minutes) => (minutes ? `${minutes}-minütiges Meeting mit` : "Meeting mit"),
        [ClientMessages.FROM]: () => "von",
        [ClientMessages.CURRENTLY_SET]: () => "Aktuell geplantes Meeting",
        [ClientMessages.BACK]: () => "Zurück",
        [ClientMessages.SET_MEETING]: () => "Meeting Einrichten",
        [ClientMessages.CHOOSE_ANOTHER]: () => "Eine andere Zeit wählen",
        [ClientMessages.MEET]: () => "Treffen",
        [ClientMessages.CALENDAR_UNAVAILABLE]: () => "Dieser Kalender steht zurzeit nicht zur Verfügung.",
        [ClientMessages.ON]: () => "Um",
        [ClientMessages.NUMBER_PROMPT]: (repName) => `Bitte geben Sie eine Telefonnumer an, damit ${repName} Kontakt mit Ihnen aufnehmen kann`,
        [ClientMessages.NAME]: () => "Name",
        [ClientMessages.EMAIL]: () => "E-Mail-Adresse",
        [ClientMessages.PHONE_NUMBER]: () => "Telefonnummer",
        [ClientMessages.SET_MEETING_ERROR]: () => "meeting konnte nicht eringerichtet werden",
        [ClientMessages.ENTER_NAME]: () => "Bitte geben Sie Ihren Namen ein",
        [ClientMessages.VALID_PHONE]: () => "Bitte geben Sie eine gültige Telefonnummer an",
        [ClientMessages.VALID_EMAIL]: () => "Bitte geben Sie eine gültige E-Mail-Adresse an",
        [ClientMessages.CONFIRMED]: () => "Bestätigt",
        [ClientMessages.SCHEDULED_FOR]: () => "ist geplant für",
        [ClientMessages.INVITE_SENT]: () => "Eine Kalendereinladung wurde an Ihre E-Mail-Adresse versendet.",
    },
};